import React from "react";
import { useTranslation } from "react-i18next";

import { Box, Chip, Typography } from "@mui/material";
import propTypes from "prop-types";

import { toLatinDigits } from "../../utils/numberFormatting";
import Discount from "../Discount";
import Price from "../Price";
import ThemedButton from "../ThemedButton";
import PackageCardWrapper from "../Wrappers/PackageCardWrapper";

const PackageCard = ({
  packageData,
  onPurchasePackage,
  bgColor,
  branchName,
  purchaseDisabled,
  isSelected,
}) => {
  const { t, i18n } = useTranslation();

  const handlePurchasePackage = () => {
    if (onPurchasePackage) onPurchasePackage(packageData);
  };

  const descriptionList = packageData.description[i18n.language]
    ?.split("-")
    .map((desc) => desc.trim())
    .filter((desc) => desc !== "");
  const planTypeLabel =
    packageData.planTypeKey === "single" && branchName
      ? `${packageData.planTypeLabel} · ${branchName}`
      : packageData.planTypeLabel;

  return (
    <PackageCardWrapper
      sx={{
        ...(bgColor ? { backgroundColor: bgColor } : {}),
        ...(isSelected
          ? { border: "2px solid", borderColor: "primary.main", transform: "translateY(-3px)" }
          : {}),
        position: "relative",
        transition: "border-color 150ms ease, transform 150ms ease",
      }}
    >
      {isSelected && (
        <Box
          aria-label={t("packagesModule.selectedPlan")}
          sx={{
            position: "absolute",
            top: 8,
            insetInlineEnd: 10,
            color: "primary.main",
            fontWeight: 700,
          }}
        >
          ✓
        </Box>
      )}
      <Typography variant="h6" fontWeight="fontWeightMedium" component="h3">
        {toLatinDigits(packageData.name[i18n.language])}
      </Typography>
      {planTypeLabel && (
        <Box sx={{ display: "flex", justifyContent: "flex-start", marginTop: 0.75 }}>
          <Chip
            size="small"
            color="primary"
            variant="outlined"
            label={toLatinDigits(planTypeLabel)}
          />
        </Box>
      )}
      {/* <Typography variant="subtitle2" fontWeight="fontWeightRegular" sx={{ marginBottom: 2 }}>
        {packageData.description[i18n.language]}
      </Typography> */}
      <ul>
        {descriptionList?.map((desc, index) => (
          <li key={index}>
            <Typography variant="body2" fontWeight="fontWeightRegular">
              {toLatinDigits(desc)}
            </Typography>
          </li>
        ))}
      </ul>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Price value={packageData.price} />
        {packageData.discountAvailable && <Discount value={packageData.amountBeforeDiscount} />}
        {packageData.discountAvailable && (
          <Chip
            size="small"
            color="success"
            label={t("packagesModule.offer")}
            sx={{ fontWeight: 700 }}
          />
        )}
      </Box>

      <ThemedButton
        variant="contained"
        color="primary"
        fullWidth
        onClick={handlePurchasePackage}
        disabled={purchaseDisabled}
      >
        {t("packagesModule.purchasePackage")}
      </ThemedButton>
    </PackageCardWrapper>
  );
};

PackageCard.propTypes = {
  packageData: propTypes.object.isRequired,
  onPurchasePackage: propTypes.func.isRequired,
  bgColor: propTypes.string,
  branchName: propTypes.string,
  purchaseDisabled: propTypes.bool,
  isSelected: propTypes.bool,
};

export default PackageCard;
